<template>
  <div id="render"
  @click="particleHitBig">
    <div class="content">
      <h1>oh<br>no<span>!</span></h1>
      <h2>Sorry, I can't find what you're looking for.<br>I even checked in the <router-link to="/" class="link-back">back.</router-link></h2>
    </div>
  <vue-headful title="DA | 404" />
  </div>
</template>

<script>
import { CanvasSpace, Create, World, Particle, Num, Pt } from 'pts'

export default {
  data () {
    return {
      particleAmt: 12,
      particleCursorSize: 20,
      particleBaseSize: 15,
      particleSizeModifier: 15,
      particleHitAmt: 25,
      particleMoveActive: true,
      particleHitTimer: 500,
      particleColor: '#e0d6cc',
      particles: []
    }
  },
  methods: {
    moveParticles () {
      this.particles.forEach(particle => {
        particle.hit(Num.randomRange(-this.particleHitAmt / 5, this.particleHitAmt / 5), Num.randomRange(-this.particleHitAmt / 5, this.particleHitAmt / 5))
      })
    },
    particleHitBig () {
      this.particles.forEach(particle => {
        particle.hit(Num.randomRange(-this.particleHitAmt * 5, this.particleHitAmt * 5), Num.randomRange(-this.particleHitAmt * 5, this.particleHitAmt * 5))
      })
    }
  },
  mounted () {
    var space = new CanvasSpace('#render').setup({ bgcolor: 'transparent', resize: true, retina: true })
    var form = space.getForm()

    var world
    // let particles =[];

    space.add({

      start: (bound, space) => {
        // Create world and 100 random points
        world = new World(space.innerBound, 1, 0)
        let pts = Create.distributeRandom(space.innerBound, this.particleAmt)

        // Create particles and hit them with a random impulse
        for (let i = 0, len = pts.length; i < len; i++) {
          let p = new Particle(pts[i]).size((i === 0) ? this.particleCursorSize : this.particleBaseSize + Math.random() * space.size.x / this.particleSizeModifier)
          p.hit(Num.randomRange(-this.particleHitAmt, this.particleHitAmt), Num.randomRange(-this.particleHitAmt / 2, this.particleHitAmt / 2))
          world.add(p)
          this.particles.push(p)
        }

        world.particle(0).lock = true // lock it to move it by pointer later on

        setInterval(() => {
          if (this.particleMoveActive) {
            this.moveParticles()
          }
        }, this.particleHitTimer)
      },

      animate: (time, ftime) => {
        world.drawParticles((p, i) => {
          let color = this.particleColor
          form.fillOnly(color).point(p, p.radius, 'circle')
        })

        world.update(ftime)
      },

      action: (type, px, py) => {
        if (type === 'move') {
          world.particle(0).position = new Pt(px, py)
        }
      },

      resize: (bound, evt) => {
        if (world) world.bound = space.innerBound
      }
    })

    space.bindMouse().bindTouch()
    space.play()
  }

}

</script>

<style lang="scss" scoped>

  #render {
    grid-area: render;
    cursor: none;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background: $gray8;
    border-left: 1px solid $gray5;
    box-sizing: border-box;
    overflow: hidden;
  }

  .content {
    position: absolute;
    text-align: center;
    pointer-events: none;
    mix-blend-mode: difference;
    user-select: none;

    h1 {
      font-family: $title-font;
      color: $white;
      position: relative;
      font-size: calc(260px + 8vw);
      line-height: 60%;
      margin-left: -12%;

      span {
        font-family: Georgia, 'Times New Roman', Times, serif;
        transform: rotate(12deg);
        position: absolute;
        bottom: -2vw;
      }
    }

    h2 {
      margin-top: 80px;
      color: $white;
      font-size: 2rem;
      line-height: 3rem;
      margin-top: 5.5rem;
      font-family: $display-font;
      padding: 0 1.5rem;

      .link-back {
        background: $white;
        color: $black;
        text-decoration: none;
        padding: 0 .5rem;
        pointer-events: visible;
      }
    }

    // h4 {
    //   position: absolute;
    //   bottom: 15.25vw;
    //   right: 6.5vw;
    //   z-index: 99;
    //   color: $black;
    //   transform: rotate(-78deg);
    //   font-size: 1vw;
    // }

    button {
      z-index: 99;
      pointer-events: visible;
    }
  }
</style>
